{
  "name": "production",
  "hostname": "serveport.com",
  "development": false,
  "production": true,
  "applicationName": "ServePort",
  "sourceVersion": "51ecffabfac73e2a61ed9d99bb7cb674aa0abd64",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_live_Js6GjAAEvwtOZ3ZNvGe149jU00TGO4Jqgw"
  },
  "auth0": {
    "authorityRoot": "auth.safarilaw.com",
    "clientId": "cPuIsG207eQuD6RWEFZmHQqbjPnPjIRk",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.serveport.com/_api/maintenance/",
    "code": "IldIjcjp1bhvMua1TOMwNdt1v7FZl3C04LmnVpQWj2pdAzFuobNqfA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": false,
    "devTools": false,
    "devExceptions": false
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "3866225d-479d-4694-ba82-471c763c47d1"
    },
    "appInsights": {
      "instrumentationKey": "6d15b261-ac17-4b93-b93a-afd6fded4add"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0
    },
    "reports": {
      "key": "Z7EC-XGIC55-0N4F3F-1V0I54-5H0S6L-2A2S08-3C0O26-4D5X6H-41036E-4M3C3L"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
